const MAX_INITIALS = 3;
const AVATAR_BACKGROUND = "#2568FF";

export const getInitialsFromEmail = (email: string | null | undefined): string => {
    if (!email || typeof email !== "string") {
        return "?";
    }

    const trimmed = email.trim();
    const atIndex = trimmed.indexOf("@");
    const localPart = (atIndex === -1 ? trimmed : trimmed.slice(0, atIndex)).trim();
    const plusIndex = localPart.indexOf("+");
    const namePart = (plusIndex === -1 ? localPart : localPart.slice(0, plusIndex)).trim();
    if (!namePart) {
        return "?";
    }

    const parts = namePart.split(/[.\-]/).filter(Boolean);
    if (parts.length === 0) {
        return "?";
    }

    return parts
        .slice(0, MAX_INITIALS)
        .map((part) => part[0])
        .join("")
        .toUpperCase();
};

export const createInitialsAvatarDataUrl = (initials: string): string => {
    const safeInitials = (initials || "?").slice(0, MAX_INITIALS).replace(/[^A-Za-z0-9?]/g, "?");
    const fontSize = safeInitials.length >= 3 ? 20 : 24;
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"><rect width="64" height="64" rx="32" fill="${AVATAR_BACKGROUND}"/><text x="32" y="34" text-anchor="middle" dominant-baseline="middle" fill="#ffffff" font-family="Arial, Helvetica, sans-serif" font-size="${fontSize}" font-weight="600">${safeInitials}</text></svg>`;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};
